import { render, staticRenderFns } from "./Appointment.vue?vue&type=template&id=0fcfabec&scoped=true"
import script from "./Appointment.vue?vue&type=script&lang=js"
export * from "./Appointment.vue?vue&type=script&lang=js"
import style0 from "./Appointment.vue?vue&type=style&index=0&id=0fcfabec&prod&lang=scss&scoped=true"
import style1 from "./Appointment.vue?vue&type=style&index=1&id=0fcfabec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcfabec",
  null
  
)

export default component.exports